import * as yup from 'yup'
import { PAGE_BLOCK_TYPES } from '../pages/skill-bite-edit/build/utils/page-block-types'

const credlyBadgeTemplateIdSchema = yup.string().test(
  'uuid-or-empty',
  'Must be a valid UUID',
  (value) => !value || yup.string().uuid().isValidSync(value)
)

const skillBiteFormSchema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
  shortDescription: yup.string().required(),
  image: yup.object().shape({
    imgUrl: yup.string().required()
  }),
  metaSkill: yup.string(),
  skill: yup.string(),
  expert: yup.boolean().required(),
  credlyBadgeTemplateId: credlyBadgeTemplateIdSchema
})

const skillBiteEmailFormSchema = yup.object().shape({
  headline: yup.string().required(),
  intro: yup.string().required(),
  cta: yup.string().required(),
  commitmentCopy: yup.string()
})

const skillBiteCommitmentCheckSchema = yup.object().shape({
  title: yup.string(),
  message: yup.string(),
  reviewLabel: yup.string()
})

const skillBitePageBlockFormSchema = yup.object().shape({
  blocks: yup.array().of(yup.object().shape({
    type: yup.string().oneOf([PAGE_BLOCK_TYPES.DRAFTJS, PAGE_BLOCK_TYPES.TINYMCE, PAGE_BLOCK_TYPES.COMMITMENT, PAGE_BLOCK_TYPES.COMMITMENT_CHECK]).required(),
    order: yup.number().required(),
    data: yup.object().when('type', {
      is: PAGE_BLOCK_TYPES.DRAFTJS,
      then: () => yup.object().shape({
        blocks: yup.array().required(),
        entityMap: yup.object()
      })
    }).when('type', {
      is: PAGE_BLOCK_TYPES.TINYMCE,
      then: () => yup.object().shape({
        html: yup.string()
      })
    }).when('type', {
      is: PAGE_BLOCK_TYPES.COMMITMENT,
      then: () => yup.object().shape({
        commitmentLabel: yup.string().required('Commitment label is required')
      })
    }).when('type', {
      is: PAGE_BLOCK_TYPES.COMMITMENT_CHECK,
      then: () => yup.object().shape({
        commitmentId: yup.string(),
        labels: yup.object().shape({
          lastTimeCommitment: yup.string(),
          yes: skillBiteCommitmentCheckSchema,
          no: skillBiteCommitmentCheckSchema
        })
      })
    })
  }))
})

const skillBitePublishSchema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
  shortDescription: yup.string().required(),
  image: yup.object().shape({
    imgUrl: yup.string().required()
  }),
  expert: yup.boolean().required(),
  sessions: yup.array().of(yup.object().shape({
    name: yup.string().required(),
    order: yup.number().required(),
    description: yup.string().required(),
    emailConfig: skillBiteEmailFormSchema.required(),
    sections: yup.array().of(yup.object().shape({
      name: yup.string().required(),
      order: yup.number().required(),
      pages: yup.array().of(yup.object().shape({
        order: yup.number().required(),
        blocks: yup.array().of(yup.object().shape({
          type: yup.string().oneOf([PAGE_BLOCK_TYPES.DRAFTJS, PAGE_BLOCK_TYPES.TINYMCE, PAGE_BLOCK_TYPES.COMMITMENT, PAGE_BLOCK_TYPES.COMMITMENT_CHECK]).required(),
          order: yup.number().required()
        })).min(1).required()
      })).min(1).required()
    })).min(1).required()
  })).min(1).required()
})

export {
  skillBiteFormSchema,
  skillBiteEmailFormSchema,
  skillBitePageBlockFormSchema,
  skillBitePublishSchema
}
